import React from 'react';
import { Container, StyledIcon } from './styled';
import { Button } from '../../../../../../../Button/styled';
import { IconName } from '../../../../../../../Icons';
export const Option = ({ name, isActive, onClick, styles, option, testID, }) => (React.createElement(Container, { style: styles.container, className: "Option", onClick: () => {
        onClick(option);
    } },
    React.createElement(Button, { testID: testID, style: styles.optionButton, className: "Option-Button", backgroundColor: "transparent" },
        React.createElement(StyledIcon, { style: styles.optionCheckMark, className: "Option-icon", "data-test": "Option-icon", name: IconName.confirm, color: "white", isActive })),
    React.createElement("span", { style: styles.optionTitle, "data-test": "Option-Name", className: "Option-Name" }, name)));
Option.defaultProps = {
    styles: {
        container: null,
        optionButton: null,
        optionCheckMark: null,
        optionTitle: null,
    },
};
//# sourceMappingURL=index.js.map